import { render, staticRenderFns } from "./JobClassificationSelector.vue?vue&type=template&id=a913d1dc&scoped=true"
import script from "./JobClassificationSelector.vue?vue&type=script&lang=js"
export * from "./JobClassificationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a913d1dc",
  null
  
)

export default component.exports